import React from "react";
import { useTranslation } from "react-i18next";
import theme from "../../elements/Theme";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";

const VideoFrame: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLaptop = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box
      sx={{
        height: "100%",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        paddingLeft: isMobile ? "20px" : "73px",
        paddingRight: isMobile ? "20px" : "73px",
      }}
    >
      <a
        href="https://youngsparrows.com/"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none" }}
      >
        <Typography
          variant="h3"
          color={theme.palette.text.secondary}
          fontWeight={600}
          textAlign="center"
          sx={{ textDecoration: "underline", mb: 8 }}
        >
          {t("videoFrame.textLink")}
        </Typography>
      </a>
      <Grid container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item xs={12} lg={8} order={isLaptop ? 1 : -1}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingBottom: "56.25%",
              border: "1px solid #009dda",
              boxShadow: "rgba(0, 157, 218, 0.6) 0px 0px 10px 5px inset",
              mx: "auto",
            }}
          >
            <Box
              component="iframe"
              src="https://player.vimeo.com/video/908820002?autoplay=1&loop=1&muted=1"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VideoFrame;
